<template>
  <div class="tw-flex tw-flex-col tw-border tw-rounded tw-overflow-hidden">
    <div
      class="tw-flex tw-items-center tw-justify-between tw-p-6"
      :class="headerClass"
    >
      <span
        v-if="!!title"
        v-text="title"
        class="tw-text-xl tw-font-semibold"
      ></span>
      <template v-else>
        <slot name="title"></slot>
      </template>
      <span
        class="tw-cursor-pointer fast-transition"
        :class="{'rotate-arrow': ! value}"
        @click="$emit('input', ! value)"
      ><i
        class="fal fa-2x fa-angle-down"
      ></i></span>
    </div>
    <el-collapse-transition>
      <div v-show="value">
        <div v-if="!!$slots.body">
          <slot name="body"></slot>
        </div>
        <div class="tw-p-6" v-else>
          <slot></slot>
        </div>
      </div>
    </el-collapse-transition>
  </div>
</template>

<script>
  import CollapseTransition
    from 'element-ui/lib/transitions/collapse-transition';

  export default {
    name: 'BlastCollapse',

    components: {
      'el-collapse-transition': CollapseTransition,
    },

    props: {
      value: {
        default: true,
        type: Boolean,
      },
      title: {
        required: false,
        type: String,
      },
      headerClass: {
        type: String,
        default: 'tw-bg-grey-lighter',
      },
    },
  };
</script>

<style>
  .rotate-arrow {
    transform: rotate(-90deg) !important;
  }
</style>
